<app-report-shell [user]="user" [currentTime]="''" [sidebarCollapsed]="sidebarCollapsed" [mobileSidebarOpen]="mobileSidebarOpen" (menuToggle)="handleMenuToggle()" (closeMobileSidebar)="closeMobileSidebar()">
  <main class="notifications-page">
    <section class="notifications-page__panel app-card">
      <header class="notifications-page__header">
        <div>
          <h2 class="app-title-serif">Notifications</h2>
          <p class="notifications-page__unread-count">
            @if (unreadCount > 0) {
              <span class="notifications-page__unread-indicator" aria-hidden="true"></span>
            }
            <span>{{ unreadCount }} unread notification{{ unreadCount === 1 ? '' : 's' }}</span>
          </p>
        </div>
        <button type="button" class="app-button app-button--secondary" [disabled]="!unreadCount || isMarkingAllRead" (click)="markAllRead()">
          {{ isMarkingAllRead ? 'Marking...' : 'Mark All Read' }}
        </button>
      </header>

      @if (isLoading) {
        <p class="notifications-page__empty">Loading notifications...</p>
      } @else if (notifications.length) {
        <div class="notifications-page__list">
          <div class="notifications-page__list-header" aria-hidden="true">
            <span>S.No.</span>
            <span>Notification</span>
            <span>Date</span>
          </div>
          @for (notification of notifications; track trackNotification($index, notification); let index = $index) {
            <button type="button" class="notifications-page__item" [class.notifications-page__item--unread]="!notification.is_read" (click)="openNotification(notification)">
              <span class="notifications-page__item-serial">{{ getNotificationSerial(index) }}</span>
              <span class="notifications-page__item-content">
                <span class="notifications-page__item-title-row">
                  <span class="notifications-page__item-indicator" aria-hidden="true"></span>
                  <span class="notifications-page__item-title">{{ notification.title }}</span>
                </span>
                @if (notification.description) {
                  <span class="notifications-page__item-description">{{ notification.description }}</span>
                }
              </span>
              <time class="notifications-page__item-date" [attr.datetime]="notification.created_at || null">{{ getNotificationDate(notification) }}</time>
            </button>
          }
        </div>
      } @else {
        <p class="notifications-page__empty">No notifications found.</p>
      }

      @if (canShowPagination()) {
        <footer class="notifications-page__pagination">
          <div class="notifications-page__pagination-summary">
            <span>{{ getPaginationLabel() }}</span>
          </div>

          <div class="notifications-page__pagination-actions">
            <button type="button" class="app-button app-button--secondary notifications-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="previousPage()">Previous</button>
            <div class="notifications-page__pagination-pages" aria-label="Pagination pages">
              @for (page of getPaginationItems(); track $index) {
                @if (page === -1) {
                  <span class="notifications-page__pagination-ellipsis" aria-hidden="true">...</span>
                } @else {
                  <button type="button" class="notifications-page__pagination-page" [class.notifications-page__pagination-page--active]="pagination.page_no === page" [disabled]="isLoading" (click)="goToPage(page)">{{ page }}</button>
                }
              }
            </div>
            <button type="button" class="app-button app-button--secondary notifications-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="nextPage()">Next</button>
          </div>

          <label class="notifications-page__pagination-size">
            <span class="notifications-page__pagination-size-label">Rows per page</span>
            <select class="app-form-select notifications-page__pagination-select" [formControl]="pageSizeControl">
              @for (size of pageSizeOptions; track size) {
                <option [ngValue]="size">{{ size }}/Page</option>
              }
            </select>
          </label>
        </footer>
      }
    </section>
  </main>
</app-report-shell>
